import React, { useMemo } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { useRouter } from '@shared/hooks/use-router'
import { apiJSON } from '@shared/utils/api/api.util'
import { useQuery } from 'react-query'
import { ProgressDownloadButton } from '@shared/components/ProgressDownloadButton'
import { originalIcons } from '@shared/components/icons/icons'
import { useThemeStyles } from '@shared/theme/use-theme-styles'
import { Table } from '@shared/components/table/table.component'
import { MTableGroupRow } from '@material-table/core'
import { Empty } from '@shared/components/empty.component'
import { TABLE_PADDING_COMMON } from '@shared/components/table/table.consts'
import Link from '@mui/material/Link'
import Button from '@mui/material/Button'

interface Act {
  lexApiUrl: string
  document: string
  acts: { lexApiUrl: string; document: string; details: string }[]
}

export function ActsPage() {
  const { query, navigate } = useRouter<{
    scopeID: string
    companyID: number
  }>()
  const { companyID, scopeID } = query

  const endpoint = `CompaniesEvaluationProfiles/${companyID}/scopes/${scopeID}/acts`
  const { data, isLoading } = useQuery(endpoint, () => apiJSON(endpoint))

  const classes = useStyles()
  const themeClasses = useThemeStyles()

  const buildExcelUrl = () => {
    return `${process.env.REACT_APP_HOST}/api/CompaniesEvaluationProfiles/${companyID}/scopes/${scopeID}/actsExcel`
  }

  const tableData = useMemo(() => {
    if (!data) return []

    return data.flatMap(({ group, acts }: { group: any; acts: any }) =>
      acts.map((act: any) => ({
        ...act,
        group,
      }))
    )
  }, [data])

  const columns = [
    {
      field: 'group',
      title: '',
      defaultGroupOrder: 0,
      width: '40px',
      customSort: () => 0,
      cellStyle: {
        ...TABLE_PADDING_COMMON,
      },
    },
    {
      field: 'document',
      title: 'Nazwa',
      width: '200px',
      cellStyle: {
        ...TABLE_PADDING_COMMON,
      },
      render: (rowData: Act) => {
        return rowData.lexApiUrl ? (
          <Link href={rowData.lexApiUrl} target="_blank" rel="noopener">
            {rowData.document}
          </Link>
        ) : (
          rowData.document
        )
      },
    },
    {
      field: 'details',
      title: 'Opis',
      cellStyle: {
        ...TABLE_PADDING_COMMON,
      },
    },
  ]

  return (
    <div>
      <div className={classes.buttonContainer}>
        <Button
          variant="outlined"
          onClick={
            () => navigate(-1)
            // navigate(`/audit/${companyID}/${auditID}`, {
            //   replace: true,
            // })
          }
          startIcon={<originalIcons.PreviousPage />}
        >
          Powrót
        </Button>
        <ProgressDownloadButton
          variant="outlined"
          downloadUrl={buildExcelUrl()}
          startIcon={<originalIcons.Send />}
        >
          Eksport do pliku
        </ProgressDownloadButton>
      </div>
      <div className={themeClasses.tableContainer}>
        <Table
          title="Rejestr aktów prawnych"
          isLoading={isLoading}
          options={{
            grouping: true,
            groupRowSeparator: ' ',
          }}
          data={tableData}
          columns={columns}
          components={{
            Groupbar: Empty,
            Header: Empty,
            GroupRow: (props) => {
              const newProps = {
                ...props,
                groupData: {
                  ...props.groupData,
                  value: (
                    <span className={classes.groupRow}>
                      {props.groupData.value}
                    </span>
                  ),
                },
              }

              return <MTableGroupRow {...newProps} />
            },
          }}
        />
      </div>
    </div>
  )
}

export const useStyles = makeStyles((theme) => {
  return {
    tableContainer: {},
    groupRow: {
      display: 'inline-flex',
      justifyContent: 'space-between',
      width: 'calc(100% - 50px)',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      fontSize: 14,
      fontWeight: 500,
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 8,
    },
  }
})
